import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function deleteDepartmentColleagues(colleagues) {
  return dispatchCommand('DeleteDepartmentColleagues', colleagues);
}
